import { Action, createReducer, on } from '@ngrx/store';

import {InterventionStructure, Metrics} from '../../../models/metrics';
import * as metricsActions from '../metrics/metrics.actions';
import { UnansweredQuestion } from '../../../models/unanswered-question';
import { Filter } from 'src/app/models/filter';
import { Intervention } from 'src/app/models/intervention';
import { Module } from 'src/app/models/module';
import { TiimStudyParticipant } from '../../../models/tiim-study-participant';

export interface MetricsState extends Metrics {
  loadingMetrics: boolean;
  metricsLoaded: boolean;
  error?: string;
  unanswered: UnansweredQuestion[];
  downloadingInterventionAnswers: boolean;
  downloadingInterventionAnswersTiming: boolean;
  interventionAnswersDownloaded: boolean;
  interventionAnswersTimingDownloaded: boolean;
  filter: Filter;
}

export const initialMetricsState: MetricsState = {
  modules: [],
  partModIds: null,
  participants: [],
  interventionStructure: [],
  loadingMetrics: false,
  metricsLoaded: false,
  unanswered: [],
  filter: null,
  downloadingInterventionAnswers: false,
  downloadingInterventionAnswersTiming: false,
  interventionAnswersDownloaded: false,
  interventionAnswersTimingDownloaded: false,
};

export const reducer = createReducer(
  initialMetricsState,
  on(metricsActions.getMetrics, (state) => {
    return {
      ...state,
      loadingMetrics: true,
      metricsLoaded: false,
    };
  }),
  on(metricsActions.getMetricsSuccess, (state, { metrics }) => {
    return {
      ...state,
      loadingMetrics: false,
      metricsLoaded: true,
      modules: metrics.modules,
      partModIds: metrics.partModIds,
      participants: metrics.participants,
      interventionStructure: metrics.interventionStructure,
    };
  }),
  on(metricsActions.getMetricsError, (state, { err }) => {
    return {
      ...state,
      loadingMetrics: false,
      metricsLoaded: false,
      error: err.error.error,
    };
  }),
  on(metricsActions.getFilters, (state) => {
    return {
      ...state,
      loadingMetrics: false,
      metricsLoaded: false,
    };
  }),
  on(metricsActions.getFiltersSuccess, (state, { filter }) => {
    return {
      ...state,
      loadingMetrics: false,
      metricsLoaded: false,
      filter: filter,
    };
  }),
  on(metricsActions.getUnansweredQuestions, (state) => {
    return {
      ...state,
      loadingMetrics: true,
      metricsLoaded: false,
    };
  }),
  on(metricsActions.getUnansweredQuestionsSuccess, (state, { unanswered }) => {
    return {
      ...state,
      loadingMetrics: false,
      metricsLoaded: true,
      unanswered,
    };
  }),
  on(metricsActions.getUnansweredQuestionsError, (state) => {
    return {
      ...state,
      loadingMetrics: false,
      metricsLoaded: false,
    };
  }),
  on(metricsActions.resetValues, (state) => {
    return {
      ...state,
      loadingMetrics: false,
      metricsLoaded: false,
    };
  }),
  on(metricsActions.getParticipantScreeningResponses, (state) => {
    return {
      ...state,
      loadingMetrics: true,
      metricsLoaded: false,
    };
  }),
  on(metricsActions.getParticipantScreeningResponsesSuccess, (state, { metrics }) => {
    return {
      ...state,
      loadingMetrics: false,
      metricsLoaded: true,
      modules: metrics.modules,
      participants: metrics.participants,
      interventionStructure: metrics.interventionStructure,
    };
  }),
  on(metricsActions.getParticipantScreeningResponsesError, (state) => {
    return {
      ...state,
      loadingMetrics: false,
      metricsLoaded: false,
    };
  }),
  on(metricsActions.downloadInterventionAnswers, (state) => {
    return {
      ...state,
      downloadingInterventionAnswers: true,
      interventionAnswersDownloaded: false,
      downloadingInterventionAnswersTiming: false,
      interventionAnswersTimingDownloaded: true,
    };
  }),
  on(metricsActions.downloadInterventionAnswersSuccess, (state) => {
    return {
      ...state,
      downloadingInterventionAnswers: false,
      interventionAnswersDownloaded: true,
      downloadingInterventionAnswersTiming: false,
      interventionAnswersTimingDownloaded: true,
    };
  }),
  on(metricsActions.downloadInterventionAnswersError, (state) => {
    return {
      ...state,
      downloadingInterventionAnswers: false,
      interventionAnswersDownloaded: false,
    };
  }),
  on(metricsActions.downloadInterventionAnswersTiming, (state) => {
    return {
      ...state,
      downloadingInterventionAnswersTiming: true,
      interventionAnswersTimingDownloaded: false,
      downloadingInterventionAnswers: false,
      interventionAnswersDownloaded: true,
    };
  }),
  on(metricsActions.downloadInterventionAnswersTimingSuccess, (state) => {
    return {
      ...state,
      downloadingInterventionAnswersTiming: false,
      interventionAnswersTimingDownloaded: true,
      downloadingInterventionAnswers: false,
      interventionAnswersDownloaded: true,
    };
  }),
  on(metricsActions.downloadInterventionAnswersTimingError, (state) => {
    return {
      ...state,
      downloadingInterventionAnswersTiming: false,
      interventionAnswersTimingDownloaded: false,
      downloadingInterventionAnswers: false,
      interventionAnswersDownloaded: false,
    };
  }),
  on(metricsActions.downloadInterventionParticipantData, (state) => {
    return {
      ...state,
      downloadingInterventionAnswers: true,
      interventionAnswersDownloaded: false,
      downloadingInterventionAnswersTiming: false,
      interventionAnswersTimingDownloaded: true,
    };
  })
);

export function MetricsReducer(state: MetricsState | undefined, action: Action) {
  return reducer(state, action);
}
